import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import authService from "../services/auth";
import PasswordInput from "../components/PasswordInput";
import { getSafeReturnPath, buildAuthLink } from "../utils/navigation";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [lockoutInfo, setLockoutInfo] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
    setLockoutInfo(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLockoutInfo(null);
    setLoading(true);

    try {
      await authService.login(formData.email, formData.password);
      navigate(getSafeReturnPath(searchParams.get("from")));
    } catch (err) {
      // Check for lockout response with remaining time
      const responseData = err.response?.data?.data;
      if (responseData?.remainingMinutes) {
        setLockoutInfo({
          remainingMinutes: responseData.remainingMinutes,
          canResetPassword: responseData.canResetPassword,
        });
      }
      setError(err.message || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Kwibl</h1>
        <h2>Sign In</h2>

        {error && (
          <div className="error-message">
            {error}
            {lockoutInfo?.remainingMinutes && (
              <p className="lockout-recovery">
                Forgot your password?{" "}
                <Link to="/forgot-password">Reset it here</Link>.
              </p>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <PasswordInput
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <Link to="/forgot-password">Forgot your password?</Link>
          </p>
          <p>
            Don't have an account?{" "}
            <Link to={buildAuthLink("/register", searchParams.get("from"))}>
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
